import * as React from "react";
import SimpleSelect, {SimpleSelectItem} from "components/form/Select/SimpleSelect";
import {InstanceEnvironmentVariable} from "client/resources/instanceEnvironmentVariablesResource";

interface InstanceEnvironmentVariableSelectProps {
    items: InstanceEnvironmentVariable[];
    value: string | undefined;
    onChange(newValue: string): void;
}

const InstanceEnvironmentVariableSelect: React.FC<InstanceEnvironmentVariableSelectProps> = props => {
    const items: SimpleSelectItem[] = [
        {value: "", text: ""},
        ...props.items.map(c => ({value: c.Id, text: c.Name})),
    ];
    return (
        <SimpleSelect
            label="By Environment Variable"
            value={props.value}
            onChange={props.onChange}
            items={items}
        />
    );
};

export default InstanceEnvironmentVariableSelect;
